import styles from './add.module.css';
import { Button } from '@mui/material';
import { Link } from '@mui/material';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { authData } from "../../components/getAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const schema = yup.object().shape({
  password: yup.string().required('This field is Required').min(6, 'Password length should be 6-15').max(15, 'Password length should be 6-15'),
  conf_password: yup.string().required('This field is Required').oneOf([yup.ref('password'), null], 'Password does not match')
});

const ChangePasswordForm = ({ id, setModalShow, setCurrentItem, setLoading }) => {
  const auth = authData();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema), mode: 'onChange'
  });

  const onSubmitLocal = async (data) => {
    setLoading(true);

    axios.post(process.env.REACT_APP_API_URL + 'v1/drivers-password-change/' + id, { password: data?.password }, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      setLoading(false);
      if (response.data.status === 'SUCCESS') {
        setModalShow(false);
        setCurrentItem(0);
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<>
    <div className={`${styles.AddUserMain}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormRow}`}>
          <div className={`${styles.FormGroup}`}>
            <label className={`${styles.FormLabel}`}>Password*</label>
            <input type="password" {...register("password")} className={`${styles.FormControl}`} autoComplete="off" />
            {errors.password && <span className={`${styles.ErrorM}`}>{errors.password.message}</span>}
          </div>
        </div>

        <div className={`${styles.FormRow}`}>
          <div className={`${styles.FormGroup}`}>
            <label className={`${styles.FormLabel}`}>Confirm Password*</label>
            <input type="password" {...register("conf_password")} className={`${styles.FormControl}`} autoComplete="off" />
            {errors.conf_password && <span className={`${styles.ErrorM}`}>{errors.conf_password.message}</span>}
          </div>
        </div>

        <div className={`${styles.FormButtonArea}`}>
          <Link onClick={(e) => { setModalShow(false); setCurrentItem(0); }} as={Button} className={`${styles.CancelBU}`}>Cancel</Link>
          <input className={`${styles.SubmitBU}`} value="Update" type="submit" />
        </div>
      </form>
    </div>
  </>)
}

export default ChangePasswordForm;